import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="ft">
      <div className="ft__inner">

        {/* Brand */}
        <div className="ft__brand">
          <div className="ft__logo-text">
            <span className="ft__logo-bracket">&lt;</span>
            <span className="ft__logo-name">CodeCrusaders </span>
            <span className="ft__logo-lc"> LC</span>
            <span className="ft__logo-bracket"> /&gt;</span>
          </div>
          <div>
            <div className="ft__brand-sub">
              Daily deep-dives — visual, pattern-first, beginner-to-pro.
            </div>
          </div>
        </div>

        {/* Links */}
        <div className="ft__links">
          <div className="ft__links-group">
            <div className="ft__links-title">Navigate</div>
            <Link className="ft__link" to="/">Home</Link>
            <Link className="ft__link" to="/potd">All Problems</Link>
            {/* <Link className="ft__link ft__link--soon" to="/lc-problems">
              LC Problems <span className="ft__soon-pill">soon</span>
            </Link>
            <Link className="ft__link ft__link--soon" to="/sheets">
              Sheets <span className="ft__soon-pill">soon</span>
            </Link> */}
          </div>
          <div className="ft__links-group">
            <div className="ft__links-title">Connect</div>
            <a className="ft__link" href="https://github.com/nandini-gangrade" target="_blank" rel="noreferrer">GitHub ↗</a>
            <a className="ft__link" href="https://youtube.com/@CodeCrusaders" target="_blank" rel="noreferrer">YouTube ↗</a>
            <a className="ft__link" href="https://leetcode.com/u/nandini-gangrade/" target="_blank" rel="noreferrer">LeetCode ↗</a>
          </div>
        </div>

      </div>

      <div className="ft__bottom">
        <div className="ft__copy">@ 2026 Nandini Gangrade.</div>
        <div className="ft__tagline">
          <span className="ft__dot" />
          One problem at a time
        </div>
      </div>
    </footer>
  );
}
